// extracted by mini-css-extract-plugin
export default {"container":"KW-z","title":"LW-z","link":"MW-z"};